import { UserDB } from "../db";
import { toastController } from "@ionic/core";


let users = [];
UserDB.users.toArray().then(res => {
    users = res;
    if (!res.length) {
        UserDB.users.put({
            firstName: "Admin",
            isAdmin: true,
            lastName: "",
            password: "123456",
            userId: 0,
            userName: "admin"
        });
    }
})
// let users = // array in local storage for registered users
// let users = JSON.parse(localStorage.getItem('users')) || [];

/**Act as a backend for authentication */
const configAuthBackend = () => {
    let realFetch = window.fetch;
    window.fetch = (url, opts) => {
        return new Promise((resolve, reject) => {
            // set api call
            setTimeout(() => {

                //authenticate or login
                if (url.endsWith('/users/authenticate') && opts.method === 'POST') {

                    // get params frm post request
                    let params = JSON.parse(opts.body);

                    // find if any user matches login credentials
                    let filteredUsers = users.filter(user => {
                        return user.userName === params.username &&
                            user.password === params.password;
                    })

                    if (filteredUsers.length) {
                        // if login details are valid return user details
                        let user = filteredUsers[0];
                        let responseJson = {
                            userId: user.userId,
                            userName: user.userName,
                            firstName: user.firstName,
                            lastName: user.lastName,
                            isAdmin: user.isAdmin,
                        };

                        resolve({
                            ok: true,
                            text: () => Promise.resolve(JSON.stringify(responseJson))
                        })
                    } else {
                        // else return error
                        console.log(filteredUsers);

                        reject('UserName or password is incorrect');
                    }

                    return;
                }

                // register user
                if (url.endsWith('/users/register') && opts.method === 'POST') {
                    // get new user object from post body
                    let newUser = JSON.parse(opts.body);

                    // validation
                    let duplicateUser = users.filter(user => { return user.userName === newUser.userName; }).length;
                    if (duplicateUser) {
                        reject('UserName "' + newUser.userName + '" is already taken');
                        return;
                    }

                    // save new user
                    newUser.userId = users.length ? Math.max(...users.map(user => user.userId)) + 1 : 1;
                    // users.push(newUser);
                    // localStorage.setItem('users', JSON.stringify(users));
                    UserDB.users.put(newUser).then(res => {
                        toastController.create({
                            color: 'success',
                            duration: 2000,
                            message: `Registered successfully`,
                            showCloseButton: true
                        }).then(toast => {
                            toast.present();
                        });
                    });


                    let responseJson = {
                        registered: true,
                        user : newUser
                    }

                    // respond 200 OK
                    resolve({ ok: true, text: () => Promise.resolve(JSON.stringify(responseJson)) });

                    return;
                }

                // get users
                if (url.endsWith('/users') && opts.method === 'GET') {
                    // check for fake auth token in header and return users if valid, this security 
                    // is implemented server side in a real application
                    if (opts.headers && opts.headers.Authorization === `Basic ${window.btoa('test:test')}`) {
                        resolve({ ok: true, text: () => Promise.resolve(JSON.stringify(users)) });
                    } else {
                        // return 401 not authorised if token is null or invalid
                        resolve({ status: 401, text: () => Promise.resolve() });
                    }
                }



                //pass through any requests not handled
                realFetch(url, opts).then(response => resolve(response))


            }, 500);
        });

    }
}

export default configAuthBackend